export default {
  proxy: (import.meta.env.VITE_USE_PROXY || 'true') === 'true',
  dataServerUrl: import.meta.env.VITE_APP_DESIGNER_URL || '',
  authProviderUrl: '/mbe/api/v2/login/providers/hpid',
  passportEndpoint: '/mbe/api/v2/access/token/by/passport',
  authSessionUrl: '/form/view/839',
  kbaseService: {
    httpServer: import.meta.env.VITE_HTTPS_KBASE,
  },
  appIdentifier: {
    domain: 'localhost',
    id: import.meta.env.VITE_APP_ID || 'aria',
    ownerId: import.meta.env.VITE_OWNER_ID || 'aws-aria-dev',
  },
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || '',
  googleAnalyticsIdOLD: import.meta.env.VITE_GOOGLE_ANALYTICS_ID_OLD || '',
  sitePagesSettings: [
    {
      name: 'default',
      template: 'aria/components/layout/LayoutMain',
      properties: {
        noFooter: 'boolean',
        noPadding: 'boolean',
        withSearch: 'boolean',
      },
    },
    {
      name: 'clean',
      template: 'src/core/layout/LayoutClean',
      properties: {},
    },
  ],
}
